import { render, staticRenderFns } from "./ElTooltip.vue?vue&type=template&id=530b168e&scoped=true&"
import script from "./ElTooltip.vue?vue&type=script&lang=js&"
export * from "./ElTooltip.vue?vue&type=script&lang=js&"
import style0 from "./ElTooltip.vue?vue&type=style&index=0&id=530b168e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530b168e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VTooltip})
